import React, { FC, useRef } from "react"
import { Props } from "./types"
import * as styles from "./styles.module.scss"
import Link from "src/utils/Link"
import { navigate } from "gatsby"
import { usePages } from "src/context/pages"

const SubNavBlog: FC<Props> = ({ categories, active }) => {
  const { currentPath } = usePages()
  const blogRef = useRef<HTMLSelectElement>(null)
  return (
    <div className={styles.container}>
      <ul className={`content-wrapper ${styles.list}`}>
        {categories.map(cat => (
          <li key={cat.name}>
            <Link
              to={`/blog/category/${cat.slug}`}
              className={
                `/blog/category/${cat.slug}` === currentPath ||
                active === cat.name
                  ? styles.active
                  : ""
              }
            >
              {cat.name}
            </Link>
          </li>
        ))}
      </ul>
      <div className={`content-wrapper ${styles.selectContainer}`}>
        <select
          className={styles.select}
          ref={blogRef}
          onChange={() => navigate(blogRef.current?.value!)}
        >
          {categories.map(cat => (
            <option
              key={cat.name}
              value={`/blog/category/${cat.slug}`}
              selected={currentPath === `/blog/category/${cat.slug}`}
            >
              {cat.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default SubNavBlog
